import { type YDatabase } from '@databases/collab/y-database';
import { CollabLayoutType } from '@databases/model/views/view';

/**
 * This migration changes layout type from card to gallery layout since card is a deprecated concept
 * Card is now referred to as Gallery
 */
export const cardToGalleryLayout = {
  version: 1755892342107, // Timestamp of the migration when it's written
  apply(_documentId: string, ydb: YDatabase) {
    for (const viewId of ydb.views) {
      const view = ydb.viewsById[viewId];
      if (view && view.layoutType === CollabLayoutType.CARD) {
        view.layoutType = CollabLayoutType.GALLERY;
      }
    }
  },
};
